import { MissingCoverage } from 'api/admin-models';
import { FilterableTable } from 'components/tables/filterable-table';
export interface MissingCoverageTableProps {
  missingCoverage: MissingCoverage[];
}

export default function MissingCoverageTable(
  props: MissingCoverageTableProps,
): JSX.Element {
  return (
    <FilterableTable<MissingCoverage>
      selectionMode="none"
      selectionTrackBy={(val) => val.id}
      columns={[
        {
          id: 'resource',
          label: 'Resource',
          defaultVisible: true,
          cell: (item) => item.resource,
        },
        {
          id: 'targetId',
          label: 'Target ID',
          defaultVisible: true,
          cell: (item) => item.target.id,
        },
        {
          id: 'targetKind',
          label: 'Target Kind',
          defaultVisible: true,
          cell: (item) => item.target.target_kind,
        },
        {
          id: 'missingVersions',
          label: 'Missing Versions',
          defaultVisible: true,
          cell: (item) =>
            item.target.versions ? item.target.versions.join(', ') : '',
        },
        {
          id: 'requiredBy',
          label: 'Required By',
          defaultVisible: true,
          cell: (item) => (item.required_by ? item.required_by.id : ''),
        },
      ]}
      data={props.missingCoverage}
    />
  );
}
